// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refresh-icon-button {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 10px;
  background: #dbeafe;
  color: #2563eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.refresh-icon-button:hover {
  background: #bfdbfe;
}

.refresh-icon-button:disabled {
  cursor: not-allowed;
  opacity: 0.75;
}

.refresh-icon-button i {
  font-size: 18px;
  line-height: 1;
}

.refresh-icon-button.spinning i {
  animation: refresh-icon-button-spin 0.7s linear infinite;
}

@keyframes refresh-icon-button-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RefreshIconButton.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".refresh-icon-button {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 10px;\n  background: #dbeafe;\n  color: #2563eb;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.refresh-icon-button:hover {\n  background: #bfdbfe;\n}\n\n.refresh-icon-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.75;\n}\n\n.refresh-icon-button i {\n  font-size: 18px;\n  line-height: 1;\n}\n\n.refresh-icon-button.spinning i {\n  animation: refresh-icon-button-spin 0.7s linear infinite;\n}\n\n@keyframes refresh-icon-button-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
